import { toast } from "react-toastify";
import { endpoints } from "../../configs/Settings";
import { useAxios } from "../../utils/useAxios";
import { HTTPResponseStatus } from "../../utils/enum";
import { useAuth } from "../../utils/useAuth";

/**
 * Serviço para envio de fluxo de ServiceRequest
 */
export class FlowServiceRequestService {
  private readonly apiUrl = `${endpoints.notification}/flows/ServiceRequest`;

  /**
   * Envia um fluxo de ServiceRequest
   * @param id ID do ServiceRequest
   * @returns Resposta da API
   * @throws Error se houver falha no envio
   */
  async sendFlow(id: string) {
    try {
      const headers = {
        Authorization: await useAuth.getUserToken(),
        Accept: "*/*"
      };

      const response = await useAxios.post(`${this.apiUrl}/${id}`, undefined, {
        headers,
        timeout: 8000,
        withCredentials: false
      });

      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`Erro no envio do fluxo: ${response.status}`);
      }

      return response.data;
    } catch (error: any) {
      console.error("FlowServiceRequestService.sendFlow:", error);
      console.error("Response data:", error.response?.data);
      console.error("Response status:", error.response?.status);
      
      if (error.response?.status === 400) {
        const errorMessage = error.response?.data?.error?.message;
        if (errorMessage) {
          toast.error(errorMessage);
        } else {
          toast.error("Erro ao enviar acompanhamento, tente novamente em instantes!");
        }
      } else {
        toast.error("Erro ao enviar acompanhamento, tente novamente em instantes!");
      }
      
      throw error;
    }
  }
}

// Instância exportada para uso direto em componentes
export const flowServiceRequestService = new FlowServiceRequestService(); 